module.exports = __webpack_public_path__ + "img/cycling.2e28f015.jpg";